import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  Bucket,
  CheckBucketResponse,
  DeleteResponse,
  CreateBucketRequest,
  GetPhotoRequest,
  DeletePhotoRequest,
} from "../models/photo.model";  // Importing types

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

export const PhotoApi = createApi({
  reducerPath: "PhotoApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Photo", "Bucket"],
  endpoints: (builder) => ({
    createBucket: builder.mutation<DeleteResponse, CreateBucketRequest>({
      query: (body) => ({
        url: "/fileManager/buckets",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Bucket"],
    }),
    checkBucket: builder.query<CheckBucketResponse, string>({
      query: (bucketName) => `/fileManager/check-bucket/${bucketName}`,
      providesTags: ["Bucket"],
    }),
    listBuckets: builder.query<Bucket[], void>({
      query: () => "/fileManager/buckets",
      providesTags: ["Bucket"],
    }),
    deleteBucket: builder.mutation<DeleteResponse, string>({
      query: (bucketName) => ({
        url: `/fileManager/buckets/${bucketName}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Bucket"],
    }),
    forceDeleteBucket: builder.mutation<DeleteResponse, string>({
      query: (bucketName) => ({
        url: `/fileManager/buckets/${bucketName}/force`,
        method: "DELETE",
      }),
      invalidatesTags: ["Bucket"],
    }),
    uploadPhoto: builder.mutation<{}, FormData>({
      query: (formData) => ({
        url: "/fileManager/upload",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Photo"],
    }),
    
    getPhotoUrl: builder.query<string, GetPhotoRequest>({
      query: ({ bucket, objectName }) => `/photo/${bucket}/${objectName}`,
      providesTags: ["Photo"],
    }),
    deletePhoto: builder.mutation<DeleteResponse, DeletePhotoRequest>({
      query: ({ bucket, objectName }) => ({
        url: `/fileManager/photo/${bucket}/${objectName}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Photo"],
    }),
  }),
});

export const {
  useCreateBucketMutation,
  useCheckBucketQuery,
  useListBucketsQuery,
  useDeleteBucketMutation,
  useForceDeleteBucketMutation,
  useUploadPhotoMutation,
  useGetPhotoUrlQuery,
  useDeletePhotoMutation,
} = PhotoApi;

export default PhotoApi;
